<div class="more-info-service-category">
  <app-collapsible
    [isPanelExpanded]="false"
    headingColor="purple-400"
    title="Looking for another service category?"
    class="no-line long-heading transparent"
    [noPadding]="!hasPadding"
  >
    <ng-container class="content">
      <div>
        <p class="half-margin-vertical">
          The service categories above are automatically supported for this client’s payments through Mable. Let us know
          if something is missing.
        </p>
        <mable-button
          category="header-detailed"
          (onClick)="openQualtricsForm()"
          class="ion-no-padding"
          icon="open"
          iconSlot="end"
        >
          Request a service
        </mable-button>
      </div>
    </ng-container>
  </app-collapsible>

  <mable-button
    category="header-detailed"
    icon="alert-circle"
    (onClick)="openServiceCategoryLink()"
    [class.ion-no-padding]="!hasPadding"
  >
    More info about service categories
  </mable-button>
</div>
